import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Rows({ color = 'icon.gray', ...props }) {
  return (
    <IconBase viewBox="0 0 22 21" {...props}>
      <Path
        d="M2.96777 4.4724H18.4778"
        stroke={color}
        strokeWidth="1.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2.96777 10.5041H18.4778"
        stroke={color}
        strokeWidth="1.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2.96777 16.5358H18.4778"
        stroke={color}
        strokeWidth="1.83"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}

Rows.propTypes = {
  color: PropTypes.string,
}

export default Rows
